/* COMPONENTS */
import Image from '@/components/ui/Image/Image';
import { Swiper, SwiperSlide } from 'swiper/react';

// Import Swiper styles
import 'swiper/css';
import 'swiper/css/pagination';

// import required modules
import { Pagination } from 'swiper/modules';

/* COMPONENT PROPS */
interface MobileCarouselProps {
  images: string[];
}

const MobileCarousel = (props: MobileCarouselProps) => {
  const { images } = props;

  return (
    <Swiper
      className='flex-1 w-full overflow-hidden h-[50vh] my-swiper'
      pagination={{
        dynamicBullets: true,
      }}
      loop
      modules={[Pagination]}
    >
      {images.map((image, key) => (
        <SwiperSlide className='my-swiper-slide' key={key}>
          <Image
            src={image}
            alt={`Product image ${key + 1}`}
            className="w-full h-full object-contain"
          />
        </SwiperSlide>
      ))}
    </Swiper>
  );
};

export default MobileCarousel;